import React, { Component } from 'react';
import { Grid, ButtonBase, Divider, Paper, CircularProgress, Button } from '@material-ui/core';
import { DateRange, QueryBuilder } from '@material-ui/icons';
import { colors, metrics } from '../styles';
import bg from '../images/bg-card.jpg';
import moment from 'moment';
import ColorService from '../tools/ColorsService';
class Step extends Component {
  render() {
    return (
      <Grid item xs={12} sm={6} md={4} lg={4} xl={3} style={{ color: colors.regular }}>
        <Paper style={{ backgroundImage: `url(${bg})`, backgroundRepeat: 'no-repeat', backgroundSize: '100%' }}>
          <ButtonBase onClick={this.props.onClick} style={{ width: '100%' }}>
            <Grid justify='center' alignItems='center' container>
              <Grid container direction="column" justify='flex-end' alignItems='flex-end' item md={12} style={{ textAlign: 'center', padding: 10 }}>
                <p style={{ marginTop: 30, padding: 0, color: colors.white, margin: 0, marginBottom: 5 }}> Etapa {this.props.index + 1}</p>
                <span style={{ backgroundColor: ColorService.backgroundColor(this.props.status), color: `${ColorService.contrastColor(this.props.satus)} !important`, padding: 2, paddingLeft: 10, paddingRight: 10, borderRadius: 4, fontSize: 10 }} >{this.props.status === 'EmAndamento' ? 'Em Andamento' : this.props.status}</span>
              </Grid>
              <Grid container >
                <Grid container style={{ textAlign: 'center', backgroundColor: colors.white, paddingBottom: 20 }} item md={6} sm={6} >
                  <Grid item md={12} sm={12}>
                    <p style={{ fontSize: 10, margin: 0, marginTop: 3 }}>ORIGEM</p>
                  </Grid>
                  <Grid item md={12} sm={12} >
                    <h3 style={{ marginLeft: 5 }}>{this.props.from || 'Não definido'}</h3>
                  </Grid>
                </Grid>
                <Grid container style={{ textAlign: 'center', backgroundColor: colors.lighter, paddingBottom: 20 }} item md={6} sm={6}>
                  <Grid item md={12} sm={12}>
                    <p style={{ fontSize: 10, margin: 0, marginTop: 3 }}>DESTINO</p>
                  </Grid>
                  <Grid item md={12} sm={12} >
                    <h3 style={{ marginLeft: 5 }}>{this.props.to || 'Não definido'}</h3>
                  </Grid>
                </Grid>
              </Grid>
              <Divider style={{ width: '100%' }} />
            </Grid>
          </ButtonBase>
          <Grid container md={12} style={{ padding: 5, paddingLeft: 8, paddingRight: 8 }}>
            <Grid container alignItems='center' item md={6}  >
              <Grid item md={2}><DateRange style={{ fontSize: 18 }} /></Grid>
              <Grid item md={10}>
                <p style={{ marginTop: 3, marginBottom: 3, marginLeft: 0, padding: 0, fontSize: 16 }}>{moment(this.props.date).format('DD/MMM/YYYY')}</p>
              </Grid>
            </Grid>
            <Grid container alignItems='center' item md={5}  >
              <Grid item md={2}><QueryBuilder style={{ fontSize: 18 }} /></Grid>
              <Grid item md={10}>
                <p style={{ marginTop: 3, marginBottom: 3, marginLeft: 0, padding: 0, fontSize: 16 }}>{this.props.local_time ? this.props.local_time.split(':')[0] + ':' + this.props.local_time.split(':')[1] : '--:--'}</p>
              </Grid>
            </Grid>
            <Grid container justify='flex-end' item md={1}>
              {this.props.id === 'new' && (
                <CircularProgress size={15} />
              )}
              {this.props.id !== 'new' && (
                <Button style={{ padding: 0 }} disabled={!this.props.disableRemove} color="secondary" onClick={() => this.props.remove(this.props.id)} ><span style={{ margin: 5, fontSize: 12 }}>REMOVER</span></Button>
              )}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    );
  }
}

export default Step;

const styles = {
  container: {
    padding: metrics.paddingPage,
    backgroundColor: colors.green500,
    paddingBottom: metrics.paddingPage + 20,
  }
}


// WEBPACK FOOTER //
// ./src/components/Step.js